import './css/App.scss';
import { Router, matchPath } from 'react-router-dom';
import ModalState from './context/modal/ModalState';
import { Web3ReactProvider } from '@web3-react/core';
import { Web3Provider } from '@ethersproject/providers';
import ConnectionState from './context/connection/ConnectionState';
import ModalsContainer from './modals/ModalsContainer';
import AppState from './context/app/AppState';
import ErrorState from './context/error/ErrorState';
import ScrollToTop from './layout/ScrollToTop';
import ThemeState from './context/theme/ThemeState';
import Maintenance from './pages/Maintenance';
import Routes, { appRoutes, vaultRoutes } from './routes';
import { SWRConfig } from 'swr';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import { createBrowserHistory } from 'history';
import DisclaimerHandler from './components/DisclaimerHandler';

const allRoutes = [...appRoutes, ...vaultRoutes].map((route) => ({ path: route }));

const history = createBrowserHistory();

Sentry.init({
    environment: 'production',
    dsn: `https://${process.env.REACT_APP_SENTRY_KEY}@o1334769.ingest.sentry.io/6601660`,
    integrations: [
        new BrowserTracing({
            routingInstrumentation: Sentry.reactRouterV5Instrumentation(
                history,
                allRoutes,
                matchPath
            ),
        }),
    ],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
});

function App() {
    const getLibrary = (provider: any): Web3Provider => {
        const library = new Web3Provider(provider);
        library.pollingInterval = 12000;

        return library;
    };

    return (
        <Router history={history}>
            <ScrollToTop />
            <SWRConfig
                value={{
                    errorRetryCount: 5,
                    dedupingInterval: 60000,
                }}
            >
                <ThemeState>
                    <ModalState>
                        <ErrorState>
                            <Web3ReactProvider getLibrary={getLibrary}>
                                <AppState>
                                    <ConnectionState>
                                        <Maintenance
                                            mode={false}
                                            development={false}
                                            developmentText='STAGING'
                                        >
                                            <DisclaimerHandler>
                                                <Routes />
                                                {/* Banner goes here */}
                                                {/* <Banner>
                                                    Following the Euler exploit and subsequent
                                                    risk mitigating measures taken by Spool,
                                                    the app is fully functioning. We will
                                                    recover as much of the lost funds as
                                                    possible and airdrop them to the affected
                                                    users as these funds become available.
                                                    Click{' '}
                                                    <ExternalLink
                                                        to={
                                                            'https://medium.com/spoolfi/spools-recovery-efforts-following-the-euler-exploit-bdcf91c8d8e6'
                                                        }
                                                    >
                                                        here
                                                    </ExternalLink>{' '}
                                                    for more details.
                                                </Banner> */}
                                            </DisclaimerHandler>
                                            <ModalsContainer />
                                        </Maintenance>
                                    </ConnectionState>
                                </AppState>
                            </Web3ReactProvider>
                        </ErrorState>
                    </ModalState>
                </ThemeState>
            </SWRConfig>
        </Router>
    );
}

export default App;
